'use client';

import React, { memo } from 'react';

import { useShowYtVideoById } from '@/hooks/api/yt/use-yt';
import { YtAnalysisContent } from '@/components/yt-analysis/yt-analysis-content';
import { YtAnalysisSkeleton } from '@/components/yt-analysis/yt-analysis-skeleton';

import { type YtVideoCardAnalysisIntent } from './yt-video-card-analysis-intent-context';

interface YtVideoCardAnalysisContentProps {
  videoId: string;
  intent?: YtVideoCardAnalysisIntent | null;
}

const PureYtVideoCardAnalysisContent: React.FC<
  YtVideoCardAnalysisContentProps
> = ({ videoId }) => {
  const { data: ytData, isLoading } = useShowYtVideoById(
    { id: videoId },
    {
      query: {
        enabled: !!videoId,
        refetchOnWindowFocus: false,
      },
    },
  );

  if (isLoading) {
    return <YtAnalysisSkeleton />;
  }

  if (!ytData) {
    return (
      <div className="dark flex size-full flex-1 flex-col space-y-3 bg-black text-[#F0F0F0] cred-md:space-y-3.5 cred-xl:space-y-5">
        <div className="flex w-full items-center justify-center py-5">
          <div className="flex flex-col items-center gap-2">
            <span className="font-semibold cred-md:text-lg">
              Video not found
            </span>
            <p className="text-xs cred-md:text-sm">
              The requested video could not be loaded
            </p>
          </div>
        </div>
      </div>
    );
  }

  return <YtAnalysisContent ytData={ytData} />;
};

export const YtVideoCardAnalysisContent = memo(
  PureYtVideoCardAnalysisContent,
  (prevProps, nextProps) => {
    return prevProps.videoId === nextProps.videoId;
  },
);
